import React, { useState } from 'react'
import { createCetegory } from '../../../services/operations/bookDetais';
import { useSelector } from 'react-redux';

function AddCategory() {
  const[categoryName,setCategoryName] = useState('');
const { token } = useSelector((state)=>state.auth)


  const submitHandler = async(e)=>{
    e.preventDefault();
    const name = categoryName
   try{
    await createCetegory(name,token);
   
   }catch(error){
    console.log(error.message)
   }


console.log(categoryName)
  } 
  return (
    <div>

      <form onSubmit={submitHandler} >
      <div className="flex flex-col space-y-2  lg:lg:w-[47%]  w-full md:w-[47%]">
              <label
                className="text-sm text-richblack-900"
                htmlFor="categoryName"
              >
               Catelog Name <sup className="text-red">*</sup>
              </label>
              <input
                id="categoryName"
                placeholder="Enter Catelog Name"
                className="two-style "
                required={true}
                onChange={(e)=> setCategoryName(e.target.value)}
              />
             

             <div className="w-full flex lg:justify-center pt-4">
              <button className="flex items-center gap-x-1 p-2 px-4 bg-yellow-100 rounded-xl font-mulish font-semibold hover:bg-yellow-50">
            <span>Submit To Add Catlog</span>
              </button>

         </div>
            </div>
      </form>
    </div>
  )
}

export default AddCategory